import { Pipe, PipeTransform } from '@angular/core';

/**
 * 將數字轉換為金額格式，並添加逗號分隔符。
 * ex. 3000 -> 3,000
 */
@Pipe({
  name: 'numberComma',
  standalone: true,
})
export class NumberCommaPipe implements PipeTransform {
  transform(value: string | number | undefined): string {
    if (value === null || value === undefined) return '';
    const num = typeof value === 'number' ? value : Number(value);
    if (isNaN(num)) return '';
    return num.toLocaleString();
  }
}
